import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import React from "react";
import {
  Redirect
} from "react-router-dom";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import styles from "./VoluntarLoginStyle";
import AppTheme from "../AppTheme";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

import AppHeader from "../AppHeader/AppHeader";

import Paper from "@material-ui/core/Paper";

import { getVoluntarById } from "../services/volunteer";

import Auth from "../modules/auth";


class VoluntarLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formInputData: {
        accessCode: ""
      },
      redirectToReferrer: false,
      errors: {
        accessCode: {
          hasError: false,
          isPristine: true,
          message: ""
        }
      }
    };
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keyPress=this.keyPress.bind(this);
  }

  login = async () => {
    
    var response = await Auth.authenticate(this.state.formInputData.accessCode,'VOLUNTAR');
    //console.log('RESPONSE', response);
    if (response) {
      this.setState(() => ({
        redirectToReferrer: true
      }));
    } else {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          accessCode: {
            hasError:true,
            isPristine: true,
            message:"Cod acces incorect!"
          }
        }
      }));
    }
  };

  handleChange(event) {
    const targetName = event.target.name;
    const value = event.target.value;
    this.setState(prevState => ({
      formInputData: {
        ...prevState.formInputData,
        [targetName]: value
      }
    }));
  }

  handleFormFieldBlur = targetName => {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [targetName]: {
          ...prevState.errors[targetName],
          isPristine: false
        }
      }
    }));
  };

  componentWillMount() {
    document.title = 'Program Voluntariat - Autentificare'
  }

  goToVreauSaFiuVoluntar() {
    document.open("/vreau-voluntar");
  }
  keyPress(e){
    if(e.keyCode == 13){
      this.login()
    }
  }

  render() {
    const { from } = this.props.location.state || {
      from: { pathname: "/programare" }
    };

    const { errors } = this.state;
    const { classes } = this.props;

    if (Auth.isUserAuthenticatedV()) return <Redirect to={from} />;
    else {
      return (
        <MuiThemeProvider theme={AppTheme}>
          <div className={classes.bedsDashboard}>
            <AppHeader className={classes.appHeader} />
            <div
              style={{
                marginTop: "300px",
                display: "flex",
                flexDirection: "column",
                flex: "1",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <h1>Programare voluntari</h1>
              <Paper
                style={{
                  minWidth: "300px",
                  minHeight: "200px",
                  padding: "20px",
                  display: "flex",
                  marginTop: "50px",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <h3>Autentificare voluntari</h3>
                <FormControl error={errors.accessCode.hasError}>
                  <InputLabel htmlFor="accessCode">Cod de access</InputLabel>
                  <Input
                    inputProps={{
                      name: "accessCode",
                      id: "accessCode"
                    }}
                    type="password"
                    required
                    value={this.state.formInputData.accessCode}
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={() => this.handleFormFieldBlur("accessCode")}
                  />
                  <FormHelperText>{errors.accessCode.message}</FormHelperText>
                </FormControl>
                <Button
                  className={classes.sendButton}
                  variant="outlined"
                  color="primary"
                  onClick={this.login}
                >
                  Trimite
                </Button>
              </Paper>

              <Button
              style={{margin:"30px 0"}}
              variant="contained"
              color="primary"
              href="/vreau-voluntar"
            >
              Vreau sa devin voluntar!
            </Button>
            </div>
          </div>
        </MuiThemeProvider>
      );
    }
  }
}

export default withStyles(styles)(VoluntarLogin);
